module.exports = __webpack_public_path__ + "img/Contacto-PeaceLilyClose.76b9f7ee.jpg";